// extracted by css-extract-rspack-plugin
export default {"ClearIcon":"DateFilterEditor-module__ClearIcon___mItsn"};